import { render, staticRenderFns } from "./WorkCurrencyTextField.vue?vue&type=template&id=2f140498&scoped=true"
import script from "./WorkCurrencyTextField.vue?vue&type=script&lang=js"
export * from "./WorkCurrencyTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkCurrencyTextField.vue?vue&type=style&index=0&id=2f140498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f140498",
  null
  
)

export default component.exports